import { useSelector } from 'react-redux';
import { getValidationErrors } from '../stores/algo-edit-config/getters';

function useAlgoValidationError(val) {
  const showError = useSelector((state) => {
    const showError = getValidationErrors(state)[val] ? true : false;

    return showError;
  });

  const helperText = useSelector((state) => {
    const helperText = getValidationErrors(state)[val]
      ? getValidationErrors(state)[val]
      : '';

    return helperText;
  });

  return [showError, helperText];
}

export default useAlgoValidationError;
